import { gql } from '@apollo/client';
export const REMOVE_API_KEY = gql `
  mutation RemoveApiKey($id: UUID!) {
    deleteWebApiClient(id: $id) {
      id
    }
  }
`;
